import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import { getLang } from "app/feature/constants";
import ClinicIcon from "../../../utils/img/clinicIcon.png";
import { CustomerSvg } from "modules/product-mgmt/utils/staticSvg";

const useStyle = makeStyles((theme) => ({
  container: {
    boxShadow: "0px 3px 7px 0px #00000029",
    borderRadius: 16,
    backgroundColor: "white",
  },
  header: {
    background: "linear-gradient(95.48deg, #1A385E 50.93%, #461E70 100%)",
    position: "relative",
    display: "flex",
    gap: "16px",
    padding: "8px 16px",
    color: "white",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    "& > img": {
      marginTop: -36,
      width: 100,
      height: 100,
      objectFit: "contain",
    },
  },
  content: {
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    padding: 18,
  },
  field: {
    padding: "2px 0px",
    width: "100%",
  },
}));

export default function AuthorisedClinicComponent({ lang, uiSetting }) {
  const classes = useStyle();

  return (
    <Box p={2}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <img src={ClinicIcon} alt="authorised clinic" />
          <Box display="flex" alignItems="center">
            <Typography variant="body1">
              <b>{getLang(lang, "label.BUYER")}</b>
            </Typography>
          </Box>
        </Box>
        <Box className={classes.content}>
          <Box display="flex" gridGap={16} alignItems="center">
            <CustomerSvg color={uiSetting.colorPrimary} />
            <Box
              className={classes.field}
              style={{ borderColor: uiSetting.colorPrimary }}
            >
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                {getLang(lang, "label.CUSTOMER_NAME")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
